import React from 'react';

import { format } from 'date-fns';

import type { PaymentStatus } from '../../model/payment';

type Props = {
  paymentStatus: PaymentStatus;
  paymentTimestampUTC: string;
};

const statusText: Record<PaymentStatus, string> = {
  IN_PROGRESS: 'In progress',
  SETTLED: 'Settled',
};

export const PaymentStatusUI = React.memo<Props>(
  ({ paymentStatus, paymentTimestampUTC }) => {
    const isPaymentSettled = paymentStatus === 'SETTLED';

    return (
      <div>
        <span
          className={`
            ${isPaymentSettled ? 'text-green-700' : 'text-base-primary'}
          `}
        >
          {statusText[paymentStatus]}
        </span>
        <br />
        {isPaymentSettled && (
          <span className="text-[13px] text-black/50">
            {format(new Date(paymentTimestampUTC), 'dd-MM-yyyy, hh:mm a')}
          </span>
        )}
      </div>
    );
  }
);
PaymentStatusUI.displayName = 'PaymentStatusUI';
